import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';

import { AppStore } from 'stores';

import { ProductId } from 'modules/program';

class BannersController implements Controller {
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "banners" */ 'features/banners/banners.page'));

  public pageId = 'Banners';

  public path = '/products/banners';
  public exact = true;

  public routeName = 'banners';

  public async fetch({ stores }: FetchOptions): Promise<Result> {
    const appStore = stores?.get<AppStore>('app');
    appStore?.setProductId(ProductId.Banners);
    appStore?.setTracking();
    appStore?.setNetworkFromRouteQuery();

    return {};
  }

  public async fetchPageData(): Promise<PageData> {
    return { title: 'Expedia Group Affiliate Banners' };
  }
}

export { BannersController };
